import { IconProps } from "./";
import Icon from "./assets/email_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Email(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
